import React from 'react';

const CardSkeleton: React.FC = () => (
  <div className=" bg-gradient-to-t from-primary to-white w-[330px] h-[339px] rounded-[25px] flex flex-col  border-[#2c5282] border-[2px] m-5 py-8 shadow-md">
    <div className=" flex flex-1 items-center justify-center">
      <svg
        className="animate-spin -ml-1 mr-3 h-10 w-10 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="#2c5282"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  </div>
);

export default CardSkeleton;
